<template>
  <div class="paintings">
    <navigation></navigation>
    <!-- Circle Preloader -->
    <h3>Installation</h3>
    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-4 ">
          <router-link to="/borneronfire">
            <img
              class="card-img-top rounded-0 "
              src="@/assets/images/installation/BorneronFire/Kunztraum.jpg"
              alt="Card image cap"
            />
          </router-link>
          <div class="card-body">
            <p class="card-text small text-center">
              <strong>Borner on Fire (Soloshow)</strong><br />
              Kunztraum, 2017 Dresden
            </p>
          </div>
        </div>

        <div class="card border-0 p-4">
          <router-link to="/heaven67">
            <img
              class="card-img-top rounded-0 "
              src="@/assets/images/installation/Heaven67/ExhibitionView3.jpg"
              alt="Card image cap"
            />
          </router-link>
          <div class="card-body">
            <p class="card-text small text-center">
              <strong>Heaven 67 (Soloshow)</strong><br />
              Streustraße, Berlin Gallery Weekend
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <router-link to="/intershop">
            <img
              class="card-img-top rounded-0"
              src="@/assets/images/installation/Intershop/Exhibitionview1.jpg"
              alt="Card image cap"
            />
          </router-link>
          <div class="card-body">
            <p class="card-text small text-center">
              <strong>Intershop (Groupshow, Kessler Schwarz)</strong><br />
              Galerie Holger John, Dresden
            </p>
          </div>
        </div>
        <!-- end row 1 -->
      </div>
      <!-- -->
    </div>

    <!--container end div-->
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
.paintings {
  overflow-x: hidden;
}
.preloader {
  padding-top: 35vh;
  width: 100%;
  height: 100vh;
  z-index: 9999999;
  background-color: #000;
}
.card {
  display: inline-block;
}
</style>
